// extracted by mini-css-extract-plugin
export var formContainer = "_ic-0";
export var message = "_ic-1";